@if (!cs.step2.skipped) {
  <div class="summary-part"
    >
    <div class="summary-part-title">
      <div class="title">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP2.TAB' | translate }}</div>
      <div class="action"
      (click)="gotoStep(1)">{{ 'BUTTON.MODIFY' | translate }}</div>
    </div>
    @if (cs.step2.valid) {
      @for (answer of cs.step2.answers; track answer) {
        <div class="summary-part-row"
          >
          <div class="summary-field label">{{ answer.question.label[this.language] }}</div>
          <div class="summary-field value"
          [innerHtml]="answer.response"></div>
        </div>
      }
    }
    @if (!cs.step2.valid) {
      <div class="summary-part-row">
        {{ 'ITSM.CREATESERVICEREQUEST.STEPS.NOTCOMPLETED' | translate }}
      </div>
    }
    <hr />
  </div>
}
